import { render } from "./LeaderTicketsView.vue?vue&type=template&id=a173cd0a&scoped=true"
import script from "./LeaderTicketsView.vue?vue&type=script&lang=js"
export * from "./LeaderTicketsView.vue?vue&type=script&lang=js"

import "./LeaderTicketsView.vue?vue&type=style&index=0&id=a173cd0a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a173cd0a"]])

export default __exports__